(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mcwebd_editor"] = factory();
	else
		root["mcwebd_editor"] = factory();
})(globalThis, () => {
return 